import { render, staticRenderFns } from "./form-content-group.vue?vue&type=template&id=8c7ea1da&"
import script from "./form-content-group.vue?vue&type=script&lang=js&"
export * from "./form-content-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c7ea1da')) {
      api.createRecord('8c7ea1da', component.options)
    } else {
      api.reload('8c7ea1da', component.options)
    }
    module.hot.accept("./form-content-group.vue?vue&type=template&id=8c7ea1da&", function () {
      api.rerender('8c7ea1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-content-group.vue"
export default component.exports